<template>
    <div class="page-footer">
        <p>中国中医科学院中医药信息研究所 中医药大健康智能研发中心</p>
        <p>地址：北京市东城区东直门内南小街16号 100700</p> 
        <slot name="content"></slot>
        <p>联系电话：010-64089619</p>
    </div>
</template>

<script>
export default {
    data () {
        return {
            infoList:[
                {
                    value:'平台介绍',
                    path:'/introPlatform'
                },
                {
                    value:'单位官网',
                    path:''
                }
            ]
        }
    } ,
    methods: {
        toPage(item){
            console.log(item)
            let routeUrl = this.$router.resolve(item.path); 
            window.open(routeUrl.href, "_blank");
        },
    }
}
</script>

<style lang="less" scoped>

</style>